import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Drawing} from '../classes/drawing';
import {Entity} from '../classes/entity';
import {EntityImage} from '../classes/entityimage';
import {Ttm} from '../classes/ttm';
import {Utils} from '../utils.class';
import {Project} from '../classes/project';
import {User} from '../classes/user';

@Injectable({
    providedIn: 'root'
})
export class DrawingService {
    private baseUrl = 'drawings';

    constructor(private apiService: ApiService) {
    }

    getDrawingByTtmId(ttmId: number) {
        return this.apiService.getCall$<Drawing>(`drawings/by-ttm/${ttmId}`);
    }

    getDrawings(orderBy?: string, orderDirection?: string, search?: string, skip = 0, limit = 6, errors = false,
                projectId?: number, drawerInitials?: string) {
        let params = {};
        if (orderBy) {
            params = {orderBy, orderDirection};
        }
        if (search) {
            params = {...params, search};
        }
        if (errors) {
            params = {...params, errors};
        }
        if (projectId) {
            params = {...params, projectId};
        }
        if (drawerInitials) {
            params = {...params, drawerInitials};
        }
        return this.apiService.getCall$<Drawing[]>(`${this.baseUrl}/${limit}/${skip}`, params);
    }

    getFilters() {
        return this.apiService.getCall$<{
            projects: Project[],
            drawers: User[]
        }>(`${this.baseUrl}/filters`);
    }

    upload(file: File) {
        return this.apiService.makeFileRequest$<{
            filename: string
        }>('drawings/upload', file);
    }

    save(drawing: Drawing) {
        return this.apiService.postCall$<Drawing>(`drawings`, drawing);
    }

    extract(id: number, onQueue: boolean, runSubsequent?: boolean) {
        return this.apiService.postCall$<Drawing>(`drawings/extract/${id}`, {onQueue, runSubsequent});
    }

    convert(id: number, onQueue: boolean) {
        return this.apiService.postCall$<string>(`drawings/convert/${id}`, {onQueue});
    }

    generateSvgs(id: number, onQueue: boolean) {
        return this.apiService.postCall$<string>(`drawings/generate-svgs/${id}`, {onQueue});
    }

    saveDrawingMaps(drawing_id: number, xRefs: any[]) {
        return this.apiService.postCall$<boolean>(`drawings/drawing-maps`, {drawing_id, xRefs});
    }

    saveEntities(drawing_id: number, entities: Entity[]) {
        return this.apiService.postCall$<boolean>(`drawings/entities`, {drawing_id, entities});
    }

    saveTtms(drawing_id: number, ttms: Ttm[]) {
        return this.apiService.postCall$<boolean>(`drawings/ttms`, {drawing_id, ttms});
    }

    getEntities(skip = 0, search?: string) {
        return this.apiService.getCall$<EntityImage[]>(`drawings/entities`, Utils.removeEmptyProps({skip, search}));
    }

    getmaps() {
        return this.apiService.getCall$<string[]>('svg/maps');
    }

    list() {
        return this.apiService.getCall$<Drawing[]>(`drawings`);
    }


    get(id: number) {
        return this.apiService.getCall$<Drawing>(`drawings/${id}`);
    }


}
